<!-- eslint-disable max-len -->
<template>
  <div class="c-popup-slide c-popup-slide--right" :id="id">
    <div class="c-popup-slide__backdrop c-btn-popup-slide-close" :data-popup-id="id"></div>
    <div class="c-popup-slide__container add_package_slide px-0">

      <!-- @start Header-->
      <div class="header_add_packagev2">
        <div class="c-btn-popup-slide-close back_button" :data-popup-id="id">
          <svg width="32" height="32" stroke-width="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="#000">
            <path d="m15 6-6 6 6 6" stroke="#000" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="header_title">Agregar paquete</div>
      </div>

      <!-- @start content-->
      <div class="body_add_packagev2">
        <div class="sections_container">

          <!-- Método de pago -->
          <div class="title_section-and-section ">
            <FormSectionTitle title="Método de pago" />
            <div style="margin: -12px -12px 0 -12px;">
              <CustomRadioButton
                radioId="opcion1"
                :inputValue="false"
                v-model="isShippingPaidAtDestination"
                label="Pago en línea"
              />
              <CustomRadioButton
                radioId="opcion2"
                :inputValue="true"
                v-model="isShippingPaidAtDestination"
                label="Pago al recoger el paquete"
                disabled
                helperText='Disponible cuando el destino es un punto Sharf'
              />
            </div>
          </div>

          <!-- Lugar de entrega -->
          <div class="title_section-and-section">
            <FormSectionTitle title="Lugar de entrega" />
            <div class="delivery-place-inputs">
              <SelectAddressButton
                @click='openAddressesModal()'
                :addressData='DestinationAddress'
              />
              <div v-if="tryToAddPackage && !DestinationAddress" style="margin-top: -15px;">
                <ErrorMessage message="Escoge un dirección." />
              </div>
            </div>
          </div>

          <!-- Datos de quien recibe -->
          <div class="title_section-and-section">
            <FormSectionTitle title="Datos de quien recibe" />
            <div class="delivery-place-inputs">
              <DestinationContactButton
                @click="openContactModal('destination'), trackEvent('click_programado_paso_3_contacto_btn', 'programado')"
                :destinationContact="DestinationContact"
                missingErrorMessage="Escoge un contacto."
              />
              <div v-if="tryToAddPackage && !DestinationContact" style="margin-top: -15px;">
                <ErrorMessage
                  message="Escoge un contacto."
                />
              </div>
            </div>
          </div>

          <!-- Características del paquete -->
          <div class="title_section-and-section">
            <FormSectionTitle title="Características del paquete" />
            <div class="delivery-place-inputs">
              <InputText
                label="Descripción del producto"
                :maxLength="150"
                placeholder="¿Qué es lo que envías?"
                v-model="productDescription"
                missingErrorMessage="Ingresa la descripción del producto."
                :showEmptyInputError="tryToAddPackage && !productDescription"
              />
              <CustomCheckbox
                checkboxId="fragile-product"
                v-model="isAFragileProduct"
                label="Producto frágil"
              />
              <div style='padding: 12px 0 16px 0'>
                <InformativeMessage :message="'¡Tus paquetes se miden en 3D! 🔍\nAunque una medida parezca grande, el volumen total podría clasificarse en una talla menor. Te ayudamos a encontrar la mejor opción según sus dimensiones completas 📏×📐×📎'" />
              </div>
              <div class="package_measurements">
                <PackageSizes :sizeList='sizeList' :sizeSelectedId='sizeSelected.tallaId' @onSizeSelected='handleSizeSelected' />
                <div v-if="sizeSelected.codigo === 'P'" class="attributes">
                  <InputPackageAttribute
                    label="Peso"
                    measure="kg"
                    v-model="packageWeight"
                    missingErrorMessage="Ingresa el Peso."
                    :showEmptyInputError="tryToAddPackage && !packageWeight"
                  />
                </div>
                <ErrorMessage v-show="exceedsWeightLimit" :message="`El peso máximo permitido por paquete en el servicio programados es ${maxWeight} kg.`" />
                <div v-if="sizeSelected.codigo === 'P'" style="padding-top: 16px;" class="attributes">
                  <InputPackageAttribute
                    label="Largo"
                    measure="cm"
                    v-model="packageWidth"
                    missingErrorMessage="Ingresa el Largo."
                    :max="maxLength"
                    :showEmptyInputError="tryToAddPackage && !packageWidth"
                  />
                  <InputPackageAttribute
                    label="Alto"
                    measure="cm"
                    v-model="packageHeight"
                    missingErrorMessage="Ingresa el Alto."
                    :max="maxLength"
                    :showEmptyInputError="tryToAddPackage && !packageHeight"
                  />
                  <InputPackageAttribute
                    label="Ancho"
                    measure="cm"
                    v-model="packageDeep"
                    missingErrorMessage="Ingresa el Ancho."
                    :max="maxLength"
                    :showEmptyInputError="tryToAddPackage && !packageDeep"
                  />
                </div>
                <ErrorMessage
                  v-if="
                    packageWidth <= maxLength &&
                    packageHeight <= maxLength &&
                    packageDeep <= maxLength
                  "
                  :message="volumetricWeightMsg"
                  v-show="exceedsVolumetricWeight"
                />
                <div class="attributes" style="padding-top: 16px">
                  <InputPackageAttribute
                    label="Valor del producto"
                    measure="S/"
                    v-model="packageValue"
                    missingErrorMessage="Ingresa el valor del producto."
                    :showEmptyInputError="tryToAddPackage && !packageValue"
                    isCurrency
                  />
                </div>
              </div>
              <div style="padding-top: 8px">
                <InformativeMessage message="Tenemos garantía de hasta S/ 1000." />
              </div>
            </div>
          </div>
          <!-- <div v-if="allowSecondAttempt">
            <div style="display: flex; flex-direction: column; gap: 4px;">
              <div class="text-l-bold">En caso el destinatario no pueda recibir el paquete</div>
              <div class="text-s-regular" style="color: #737373">Escoge una opción</div>
            </div>
            <div class="secondAttemptOption_container">
              <SecondAttempCards
                :optionSelected="secondAttemptInPS"
                :isLoading="shippingCostIsLoading"
                :aditionalCostCalculated="aditionalCostCalculated"
                @onUpdateOption="updateSecondAttemptOption"
              />
            </div>
            <div class="text-s-regular">El cobro adicional se realizaría solo en caso de que hubiese un 2do intento de entrega en domicilio, luego de haber coordinado contigo.</div>
          </div> -->

        </div>

        <div class="body_footer">
          <div>
            <ButtonDefinitive
              :isDisabled="shippingCostIsLoading"
              label="Guardar paquete"
              @click="handleAddPackage"
            />
          </div>
          <ShippingCost v-if='!IS_AN_EMBASSY_USER' :isLoading="shippingCostIsLoading" :amount="shippingCost" />
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import M from "materialize-css";
import CustomRadioButton from "../Form/CustomRadioButton.vue";
import InputDistrict from "../General/InputDistrict.vue";
import FavoriteAddress from "../General/FavoriteAddress.vue";
import Map from "../../commons/mixins/maps";
import { getScharffDistrics, getProgrammedFare, getFare, getSizes } from "../../services/fare";
import FormSectionTitle from "../Form/FormSectionTitle.vue";
import DestinationContactButton from "../Button/DestinationContactButton.vue";
import ErrorMessage from "../ErrorMessage.vue";
import InputText from "../Form/InputText.vue";
import InputPackageAttribute from "../Form/InputPackageAttribute.vue";
import CustomSearchSelect from "../Form/CustomSearchSelect.vue";
import CustomCheckbox from "../Form/CustomCheckbox.vue";
import InformativeMessage from "../General/InformativeMessage.vue";
import ButtonDefinitive from "../Button/ButtonDefinitive.vue";
import ShippingCost from "../General/ShippingCost.vue";
import SecondAttempCards from "../Shared/SecondAttempt/SecondAttempCards.vue" 
import PackageSizes from "@/components/Shared/PackageSizes.vue";
import SelectAddressButton from "@/components/Button/SelectAddressButton.vue"

function debounce(func, wait) {
  let timeout
  return function executedFunction(...args) {
    const later = () => {
      timeout = null
      func(...args)
    }
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}


export default {
  components: {
    FormSectionTitle,
    DestinationContactButton,
    CustomRadioButton,
    ErrorMessage,
    InputText,
    InputPackageAttribute,
    CustomSearchSelect,
    CustomCheckbox,
    InformativeMessage,
    ButtonDefinitive,
    ShippingCost,
    SecondAttempCards,
    PackageSizes,
    SelectAddressButton,

    InputDistrict,
    FavoriteAddress,
  },
  name: "ModalProgrammedPackage",
  props: {
    id: String,
  },
  data() {
    return {
      productDescription: '',
      destinationDistrictData: {},
      tryToAddPackage: false,
      isAFragileProduct: false,
      scharffPointsList: [],
      maxLength: null,
      maxWeight: null,
      maxVolumetricWeight: null,
      packageWeight: 0,
      packageWidth: 0,
      packageHeight: 0,
      packageDeep: 0,
      packageValue: 0,
      adicionalInformation: '',
      shippingCostIsLoading: false,
      shippingCost: 0,
      package: {
        hasValueCalculable: false,
        isAddableToList: false
      },
      isShippingPaidAtDestination: false,
      allowSecondAttempt: false,
      secondAttemptInPS: true,
      aditionalCostCalculated: 0,
      sizeList: [],
      sizeSelected: {
        tallaId: null,
        codigo: '',
        descripcion: '',
        alto: null,
        ancho: null,
        profundidad: null,
        pesoMinimo: null,
        pesoMaximo: null,
      },
      packageSize: {
        height: 0, // Altura
        lengths: 0, // Largo
        width: 0, // Ancho
        type: "Personalizado",
        weight: 0,
        maxWeight: 1000, // Peso
      },
    };
  },
  computed: {
    user() {
      return this.$store.getters.USER;
    },
    IS_AN_EMBASSY_USER() {
      return this.$store.getters.IS_AN_EMBASSY_USER;
    },
    originDistric() {
      return this.$store.getters.SCHARFFPOINT_ORDER_ORIGIN;
    },
    exceedsWeightLimit() {
      return this.packageWeight > this.maxWeight
    },
    volumetricWeight() {
      const a = this.packageWidth
      const b = this.packageHeight
      const c = this.packageDeep
      return a * b * c
    },
    exceedsVolumetricWeight() {
      if (this.sizeSelected.codigo !== 'P') return false
      return this.volumetricWeight > this.maxVolumetricWeight
    },
    volumetricWeightMsg() {
      const formatter = new Intl.NumberFormat('en-US', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 0,
      }); 
      const maxValue = this.maxVolumetricWeight
      const currentValue = this.volumetricWeight
      return `El volumen máximo por paquete en el servicio Puerta Puerta es ${formatter.format(maxValue)} cm³. Has ingresado un volumen de ${formatter.format(currentValue)} cm³.`
    },
    DestinationContact() {
      return this.$store.getters.GENERAL_DESTINATION_CONTACT;
    },
    DestinationAddress() {
      return this.$store.getters.GENERAL_DESTINATION_ADDRESS
    },
  },
  created() {
    this.$watch(() => [
      this.DestinationAddress,
      this.DestinationContact,
      this.productDescription,
      this.packageWeight,
      this.packageWidth,
      this.packageHeight,
      this.packageDeep,
      this.packageValue,
      this.shippingCost,
    ], () => { this.checkValues() })
    this.$watch(() => [
      this.DestinationAddress,
      this.packageWeight,
      this.packageWidth,
      this.packageHeight,
      this.packageDeep,
    ], debounce(this.checkValuesToCalculate, 300))
    this.$watch(() => [
      this.DestinationAddress,
      this.packageWeight,
      this.packageWidth,
      this.packageHeight,
      this.packageDeep,
    ], () => { this.shippingCostIsLoading = true })
    this.$eventBus.$on("programmedClearDataDestinationModal", () => {
      this.clearData();
    });
    this.$eventBus.$on("programmedSetDataDestinationModal", (destination) => {
      this.setData(destination);
    });
    this.getSizesForProgrammed()

    if (navigator.userAgent.match(/(iPod|iPhone|iPad)/) && navigator.userAgent.match(/AppleWebKit/)) {
      this.$nextTick(() => {
        const appContainer = document.querySelector('.body_add_packagev2');
        if (appContainer) {
          appContainer.classList.add('ios-safari');
        }
      });
    }
  },
  methods: {
    getScharffDistrics,
    getSizes,
    setDestinationDistrictData(districtData) {
      if([67, 128].includes(districtData.provinceId)) { // callao y lima
        this.secondAttemptInPS = this.secondAttemptInPS ?? true
        this.allowSecondAttempt = true
      } else {
        this.allowSecondAttempt = false
        this.secondAttemptInPS = null
      }
      this.destinationDistrictData = districtData
    },
    async checkValues() {
      const {
        DestinationAddress, exceedsVolumetricWeight,
        DestinationContact, productDescription, packageWeight, maxLength, exceedsWeightLimit,
        packageWidth, packageHeight, packageDeep, packageValue
      } = this

      const hasValueCalculable = (
        DestinationAddress.districtId &&
        packageWeight && !exceedsWeightLimit &&
        packageWidth && packageWidth <= maxLength &&
        packageHeight && packageHeight <= maxLength &&
        packageDeep && packageDeep <= maxLength && !exceedsVolumetricWeight
      )

      this.package.isAddableToList = (
        hasValueCalculable &&
        packageValue &&
        this.shippingCost > 0 &&
        DestinationContact &&
        productDescription &&
        !this.shippingCostIsLoading
      )
      console.log('hasValueCalculable: ', hasValueCalculable)
      console.log('packageValue: ', packageValue)
      console.log('this.shippingCost: ', this.shippingCost)
      console.log('DestinationContact: ', DestinationContact)
      console.log('productDescription: ', productDescription)
      console.log('this.shippingCostIsLoading: ', this.shippingCostIsLoading)
      console.log('this.package.isAddableToList: ', this.package.isAddableToList)

    },
    async checkValuesToCalculate() {
      const {
        DestinationAddress, packageWeight, packageWidth, packageHeight, packageDeep,
        exceedsVolumetricWeight, exceedsWeightLimit, maxLength
      } = this

      const hasValueCalculable = (
        DestinationAddress.districtId &&
        packageWeight && !exceedsWeightLimit &&
        packageWidth && packageWidth <= maxLength &&
        packageHeight && packageHeight <= maxLength &&
        packageDeep && packageDeep <= maxLength && !exceedsVolumetricWeight
      )

      this.package.hasValueCalculable = hasValueCalculable
      if (hasValueCalculable) await this.calculateCost()
      else this.shippingCost = 0
      this.shippingCostIsLoading = false
    },
    async calculateCost() {
      this.shippingCostIsLoading = true
      try {
        const fare = await getFare({
          "fareItems": [
            {
              "originDistrictId": this.originDistric.districtId.id,
              "destinationDistrictId": this.DestinationAddress.districtId,
              "packageWidth": this.packageWidth,
              "packageHeight": this.packageHeight,
              "packageWeight": this.packageWeight,
              "packageDeep": this.packageDeep,
              "serviceType": 2,
              "sizeId": this.sizeSelected.tallaId,
              "shippingTypeId": 4 // Programados
            }
          ],
          "userId": this.user?.id || null
        })
        this.shippingCost = fare.data.totalFare
        this.aditionalCostCalculated = fare.data.secondTryFare.toFixed(2) || 0
      } catch (e) {
        this.$swal({
          title: "Error!",
          text: e,
          icon: "error",
        })
      } finally {
        this.shippingCostIsLoading = false
      }
    },
    handleAddPackage() {
      this.trackEvent('click_programado_paso_3_guardar_paquete', 'programado')
      try {
      this.tryToAddPackage = true
      if(!this.package.isAddableToList) {
        this.$swal({
          text: '¡Ups! 😅 Parece que hay algunos campos que aún no has completado correctamente.',
          icon: "warning",
          confirmButtonText: "Aceptar"
        })
        return
      }

      const allPackageData = {
        index: this.$store.getters.PROGRAMMED_INDEX_DESTINATION,
        item: {
          description: this.productDescription,
          destinationAddress: {
            contact: this.DestinationContact,
            address: this.DestinationAddress,
            puntoScharffId: ''
          },
          discountFare: null,
          fare: this.shippingCost,
          secondAttemptInPS: this.secondAttemptInPS,
          isPointPoint: null,
          packageSize: {
            height: this.packageHeight,
            lengths: this.packageDeep,
            maxWeight: null,
            type: null, // lo que era "pequeño", "mediano", etc
            weight: this.packageWeight,
            width: this.packageWidth
          },
          fragil: this.isAFragileProduct,
          productValue: this.packageValue,
          sizeSelected: this.sizeSelected,
          shippingTypeId: 4 // Programados
        },
      }
      this.$store.dispatch("PROGRAMMED_ORDER_SET_DESTINATION", allPackageData);
      const popup = document.getElementById(this.id)
      popup.classList.remove("is-active");
    } catch (e) {
        console.log({e})
      }
    },
    updateSecondAttemptOption(option) {
      this.secondAttemptInPS = option
    },
    async getSizesForProgrammed(type) {
      const sizes = await this.getSizes(type)
      const personalizedSize = sizes.find(size => size.codigo === 'P')
      this.maxLength = personalizedSize.alto
      this.maxWeight = personalizedSize.pesoMaximo
      this.maxVolumetricWeight = personalizedSize.pesoMaximo * 5000
      this.sizeList = sizes
    },
    handleSizeSelected(size) {
      this.sizeSelected = size
      if (size.codigo === 'P') {
        this.packageWeight = 0
        this.packageWidth = 0
        this.packageHeight = 0
        this.packageDeep = 0
      } else {
        this.packageWeight = size.pesoMaximo
        this.packageWidth = size.ancho
        this.packageHeight = size.alto
        this.packageDeep = size.profundidad
      }
    },
    async openAddressesModal() {
      this.showLoading();
      await this.$store.dispatch('GET_FAVORITE_LOCATIONS')
      const modalAddressFavorite = document.querySelector('#modal-address-destination')
      const instance = M.Modal.init(modalAddressFavorite, {
        dismissible: false
      })
      instance.open()
      this.$swal.close()
    },
    openContactModal(type) {
      this.showLoading();
      this.$store
        .dispatch("GET_CONTACTS")
        .then((success) => {
          this.$swal.close();
          if (success.status === 200) {
            const contacts = success.data.result.list;
            this.$store.dispatch("GENERAL_SET_CONTACTS", contacts);
            this.$store.dispatch("HELPER_SET_MODAL_CONTACT_TYPE", type);
            const modalContactFavorite = document.querySelector("#modal-contact-destination");
            const instance = M.Modal.init(modalContactFavorite, {
              dismissible: false,
            });
            instance.open();
          } else {
            this.showError(success.data.message);
          }
        })
        .catch((error) => {
          const msg = error?.data?.message || "Ocurrio un error.";
          this.showError(msg);
        });
    },
    clearData() {
      this.$store.dispatch("HELPER_SET_ADD_DESTINATION_CONTACT", null);
      this.$store.dispatch("HELPER_SET_ADD_DESTINATION_ADDRESS", null)
      this.productDescription = ''
      this.isAFragileProduct = false
      this.packageWeight = 0
      this.packageWidth = 0
      this.packageHeight = 0
      this.packageDeep = 0
      this.packageValue = 0
      this.secondAttemptInPS = true
      this.adicionalInformation = ''
      this.package = {
        hasValueCalculable: false,
        isAddableToList: false
      }
      this.shippingCostIsLoading = false
      this.shippingCost = 0
      this.tryToAddPackage = false
      this.destinationDistrictData = {}
      this.sizeSelected = {
        tallaId: null,
        codigo: '',
        descripcion: '',
        alto: null,
        ancho: null,
        profundidad: null,
        pesoMinimo: null,
        pesoMaximo: null,
      }
    },
    setData(destination) {
      try {
        this.$store.dispatch("HELPER_SET_ADD_DESTINATION_CONTACT", destination.destinationAddress.contact);
        this.$store.dispatch("HELPER_SET_ADD_DESTINATION_ADDRESS", destination.destinationAddress.address)
        this.productDescription = destination.description
        this.packageWeight = destination.packageSize.weight
        this.packageWidth = destination.packageSize.width
        this.packageHeight = destination.packageSize.height
        this.packageDeep = destination.packageSize.lengths
        this.packageValue = destination.productValue
        this.secondAttemptInPS = destination.secondAttemptInPS
        this.isAFragileProduct = destination.fragil
        this.package = {
          hasValueCalculable: true,
          isAddableToList: true
        }
        this.shippingCostIsLoading = false
        this.shippingCost = destination.fare
        this.tryToAddPackage = false
        this.sizeSelected = destination.sizeSelected
      } catch (e) {
        console.log(e)
      }
    },
  },
};
</script>

<style>
@import '../../styles/09-componentsv2/addPackage.scss';

/* .secondAttemptOption_container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 8px;
  padding: 24px 0;
} */

/* .secondAttemptOption_body {
  display: flex;
  flex-direction: column;
} */

@media screen and (max-device-width: 580px) {
  .ios-safari {
    padding-bottom:10em;
  }
}
</style>
